module.exports = __webpack_public_path__ + "media/images/icons/eye_black-7dc3ffb16f76cdf2c510ddaef1564f7d.svg";